import React from "react";
import { useTranslation } from "react-i18next";
import ListCamera from "./listCamera";
import BasicTabs from "components/BasicTabs";
import { ALL_PERMISSION } from "constants/permission";

const CameraRegistration = () => {
  const { t: translation } = useTranslation();
  const listTab = [{
      key: "list",
      label :translation("camera.list"),
      permission: undefined,
      component: <ListCamera />
    }
  ]
  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_CAMERA.permissionTab} />
  );
};

export default CameraRegistration;
